/**
 * Created by Ning Jiang on 1/31/2018.
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";

export class WildNudgeGameAssets {

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("NumbersHotNudge", "fonts/bitmapfonts/NumbersHotNudge.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainBackground", "images/background/maingame_background.jpg"),
                    new TextureAsset("freespinBackground", "images/background/FS_background.jpg"),
                    new TextureAsset("redOverlay", "images/background/RedLightFreeSpins.jpg"),
                ]
            }
        ],
        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("mainJpeg0", "sheets/main/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/main/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/main/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/main/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/main/mainJpeg4.json"),
                ],
                animations : {
                    "machine" : "background/machine",
                    "reelBg" : "ReelArea",
                    "multiplierBg" : "Multiplier-Counter-bg",
                    "freespinPanelBg" : "FS-panelBackground",
                    "feature_J" : "randomfeature/Jdisplay",
                    "feature_Q" : "randomfeature/Qdisplay",
                    "feature_K" : "randomfeature/Kdisplay",
                    "wild_fire" : "WildFireLoop-half/WildFireLoop_",
                    "wild_smokeBurst" : "smokeburst-HALF/smokeburst_",
                    "red_fire" : "RedFire/RedFire",
                    "steam" : "Steam/Steam_",

                    "wheel1Shape" : "background/gearAnim/Wheel1-shape",
                    "wheel1Shadow" : "background/gearAnim/Wheel1-shadow",
                    "wheel13d" : "background/gearAnim/Wheel1-3d",
                    "wheel2Shape" : "background/gearAnim/Wheel2-shape",
                    "wheel2Shadow" : "background/gearAnim/Wheel2-shadow",
                    "wheel23d" : "background/gearAnim/Wheel2-3d",
                    "chain" : "background/Chain",

                    "component1" : "background/shakingParts/Component1",
                    "component2" : "background/shakingParts/Component2",
                    "component3" : "background/shakingParts/Component3",
                    "component4" : "background/shakingParts/Component4",
                    "component5" : "background/shakingParts/Component5",

                    "FSIndicatorUpperLid" : "fs/FSlid1",
                    "FSIndicatorBottomLid" : "fs/FSlid2",
                    "lightBulb" : "LightBulb",
                    "extraLid" : "ExtraLid",
                    "freespinsText" : "fs/FreeSpinsText",
                    "freespinFire" : "fs/FreeSpinsFire/FreeSpinsFire-",
                    "freespinLights" : "fs/FreeSpinsLights",
                    "fsOutroStripe" : "fs/FS-outro-stripe",
                    "freespinSeven" : "fs/7",
                    "freespinAdd1" : "PlusOneFreeSpin",

                    "bigWinBlazing" : "bigwin/BIGWIN-1-blazing",
                    "bigWinScorching" : "bigwin/BIGWIN-2-scorching",
                    "bigWinAtomic" : "bigwin/BIGWIN-3-atomic",
                    "bigWinTextGlow" : "BigWinTextGlow",
                    "bigWinReelsLight" : "LightClusterBigwin",

                    "redFlashLight" : "fs/RedFlashLight/RedFlashLight",
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbolsJpeg0", "sheets/symbols/symbolsJpeg0.json"),
                    new TextureAsset("symbolsJpeg1", "sheets/symbols/symbolsJpeg1.json"),
                    new TextureAsset("symbolsJpeg2", "sheets/symbols/symbolsJpeg2.json"),
                    new TextureAsset("symbolsJpeg3", "sheets/symbols/symbolsJpeg3.json"),
                    new TextureAsset("symbolsJpeg4", "sheets/symbols/symbolsJpeg4.json")
                ],
                animations : {
                    "L1_normal" : "L1/L1",
                    "L1_spin" : "L1/L1_spin",
                    "L1_win" : "L1/L1_win",
                    "L2_normal" : "L2/L2",
                    "L2_spin" : "L2/L2_spin",
                    "L2_win" : "L2/L2_win",
                    "L3_normal" : "L3/L3",
                    "L3_spin" : "L3/L3_spin",
                    "L3_win" : "L3/L3_win",
                    "L4_normal" : "L4/L4",
                    "L4_spin" : "L4/L4_spin",
                    "L4_win" : "L4/L4_win",
                    "M1_normal" : "M1/M1",
                    "M1_spin" : "M1/M1_spin",
                    "M1_win" : "M1/M1_win",
                    "M1_fire" : "M1/WildFireLoopBlue/King-WildFireLoop_",
                    "M2_normal" : "M2/M2",
                    "M2_spin" : "M2/M2_spin",
                    "M2_win" : "M2/M2_win",
                    "M2_fire" : "M2/WildFireLoopGreen/Queen-WildFireLoop_",
                    "M3_normal" : "M3/M3",
                    "M3_spin" : "M3/M3_spin",
                    "M3_win" : "M3/M3_win",
                    "M3_fire" : "M3/WildFireLoopOrange/Jack-WildFireLoop_",
                    "S_normal" : "S/S",
                    "S_spin" : "S/S_spin",
                    "S_win" : "S/S_win",
                    "S_fire" : "S/ScatterAttention/S_Attention",
                    "W_normal" : "W/W",
                    "W_spin" : "W/W_spin",
                    "W_win" : "W/WildWinAnimation/W_Win",
                    "fire_win" : "FireWinPresentation/WinPres",
                    "idle_fire_win": "IdleWinPresentation/Idle-WinPres",

                    "mult_0" : "multiplierNumbers/0",
                    "mult_1" : "multiplierNumbers/1",
                    "mult_2" : "multiplierNumbers/2",
                    "mult_3" : "multiplierNumbers/3",
                    "mult_4" : "multiplierNumbers/4",
                    "mult_5" : "multiplierNumbers/5",
                    "mult_6" : "multiplierNumbers/6",
                    "mult_7" : "multiplierNumbers/7",
                    "mult_8" : "multiplierNumbers/8",
                    "mult_9" : "multiplierNumbers/9",

                    "numbersFS" : "NumbersFS",
                }
            }
        ]
    };
}